{
  "randevu": {
    "Randevular": "Randevular",
    "Randevu Ekle": "Randevu Ekle",
    "Randevu": "Randevu",
    "Müşteri": "Müşteri",
    "Tarih": "Tarih",
    "Başlama Saat": "Başlama Saat",
    "Bitiş Saat": "Bitiş Saat",
    "Görüşme": "Görüşme",
    "Not": "Not",
    "Ulaşım": "Ulaşım",
    "Görüşmeye Katılanlar": "Görüşmeye Katılanlar",
    "Görüşme Sonuç": "Görüşme Sonuç",
    "Tekrar Tarih": "Tekrar Tarih",
    "Tekrar Başlama Saat": "Tekrar Başlama Saat",
    "Tekrar Bitiş Saat": "Tekrar Bitiş Saat",
    "Randevu Bilgi": "Randevu Bilgi",
    "Onay Bekliyor": "Onay Bekliyor",
    "Saat Kontrol": "Saat Kontrol"
  }
}
